import React from 'react';
import { Table, Popup, Message, Grid } from 'semantic-ui-react';
import { FieldArray } from 'formik';
import { withTranslation } from 'react-i18next';
import connect from 'react-redux/es/connect/connect';
import { compose } from 'redux';
import { groupBy } from 'lodash-es';

import { AccordionWrapper } from 'react-lib/dist/components-es';
import { HAZARD_TYPE_ENV_HAZARDS, VIEW_MODE, separators } from '../../../../constants';
import { risksActions } from '../../../../behavior/risks';
import { getHazardIconPath } from '../../../../utils';

class CPHazardsContainer extends React.PureComponent {
  componentWillReceiveProps(newProps) {
    if (newProps.hazardsCalculation !== this.props.hazardsCalculation)
      this.updateHazards(newProps.values.chemicalProduct);
  }

  updateHazards = chemicalProduct => {
    let newHazardIds = chemicalProduct.hazardStatements
      .flatMap(hs => hs.hazards)
      .flatMap(h => h.hazardId);
    const isNanomaterialSelected =
      chemicalProduct.hazards && chemicalProduct.hazards.some(h => h.id === 11);
    if (isNanomaterialSelected) newHazardIds.push(11);

    let currentHazardIds = chemicalProduct.hazards && chemicalProduct.hazards.flatMap(h => h.id);
    if (currentHazardIds !== newHazardIds) {
      this.props.setFieldValue(
        'chemicalProduct.hazards',
        this.props.initialData.hazardList.filter(h => newHazardIds.includes(h.id))
      );
      setTimeout(() => {
        this.props.envRiskCalculation();
      }, 0);
    }
  };

  isHazardSelected = hazardsGroupByGhsCode => {
    return (
      this.props.hazards &&
      this.props.hazards.some(h => hazardsGroupByGhsCode.map(gh => gh.id).includes(h.id))
    );
  };

  onSelect = (arrayHelpers, hazardsGroupByGhsCode) => {
    let indexes = hazardsGroupByGhsCode
      .map(gh => this.props.hazards.map(h => h.id).indexOf(gh.id))
      .sort((a, b) => b - a); //sort because removal must always start from the last index
    //removal or add, will be the same for all elements
    if (indexes[0] != -1) indexes.filter(i => i != -1).forEach(index => arrayHelpers.remove(index));
    else {
      hazardsGroupByGhsCode.forEach(hazard => {
        arrayHelpers.push(hazard);
      });
    }
    if (hazardsGroupByGhsCode[0].hazardType.code == HAZARD_TYPE_ENV_HAZARDS) {
      setTimeout(() => {
        this.props.envRiskCalculation();
      }, 0);
    }
  };

  render() {
    return (
      <AccordionWrapper
        {...this.props}
        closable={false}
        accordionTitle="chemical.product.details.page.hazards.container.title"
        className=""
        render={this.getHazardsContainerContent}
      />
    );
  }

  getHazardsContainerContent = () => {
    return (
      <Grid unstackable="true" columns={1} verticalAlign="bottom">
        {this.isWarningVisible() && <Grid.Column>{this.getWarning()}</Grid.Column>}
        <Grid.Column>
          <FieldArray
            validateOnChange={false}
            name={this.props.arrayName}
            render={arrayHelpers => (
              <Table unstackable basic="very" className="borderlessTable noPadding noMargin">
                <Table.Body>{this.getTableRows(arrayHelpers)}</Table.Body>
              </Table>
            )}
          />
        </Grid.Column>
      </Grid>
    );
  };

  getWarning = () => {
    const { t } = this.props;
    let warning = { msg: 'chemical.product.details.page.hazards.container.hazards.warning' };

    return (
      <div className="containerReducedWhiteSpace">
        <Message color="yellow">{t(warning.msg, warning.params)}</Message>
      </div>
    );
  };

  isWarningVisible = () => {
    const { mode, isChemProdRouter, values } = this.props;
    return (
      (isChemProdRouter && mode != VIEW_MODE) ||
      (!isChemProdRouter &&
        values.chemicalProduct &&
        values.chemicalProduct.selectedChemicalProduct &&
        values.chemicalProduct.selectedChemicalProduct.id === -1)
    );
  };

  getTableRows = arrayHelpers => {
    const rows = [];
    const { initialData, t, disabled, chemicalProductDisabled, showAllHazards } = this.props;
    const { chemicalProduct } = this.props.values;
    const hazardStmtsExist =
      chemicalProduct &&
      chemicalProduct.hazardStatements &&
      chemicalProduct.hazardStatements.length > 0;

    initialData.hazardTypeList.forEach(hazardType => {
      let allHazardsGroupByGhsCode = groupBy(
        initialData.hazardList.filter(h => h.hazardType.id == hazardType.id),
        'ghsCode'
      );

      rows.push(
        <Table.Row key={hazardType.id}>
          <Table.Cell width="3">{t(hazardType.code)}</Table.Cell>

          {Object.keys(allHazardsGroupByGhsCode).map(ghsCode => {
            let hazardsGroupByGhsCode = allHazardsGroupByGhsCode[ghsCode];
            const isHazardSelected = this.isHazardSelected(hazardsGroupByGhsCode);
            return (
              (showAllHazards || isHazardSelected) && (
                <Table.Cell
                  width="2"
                  key={hazardsGroupByGhsCode[0].id}
                  selectable
                  textAlign="center"
                  verticalAlign="middle"
                  className={this.getGrayscaleOpacity(isHazardSelected)}
                  onClick={() =>
                    !(
                      disabled ||
                      chemicalProductDisabled ||
                      (hazardStmtsExist && hazardsGroupByGhsCode[0].id !== 11)
                    )
                      ? this.onSelect(arrayHelpers, hazardsGroupByGhsCode)
                      : null
                  }
                  content={this.getHazardIcon(hazardsGroupByGhsCode)}
                />
              )
            );
          })}
        </Table.Row>
      );
    });
    return rows;
  };

  getGrayscaleOpacity = isHazardSelected => {
    if (!isHazardSelected) return 'grayscale hazardOpacity';
    else return null;
  };

  getHazardIcon = hazardsGroupByGhsCode => {
    let selectedHazardsGroupByGhsCode = this.props.hazards.filter(h =>
      hazardsGroupByGhsCode.map(gh => gh.id).includes(h.id)
    );

    let selectedOrAllHazardsGroupByGhsCode =
      selectedHazardsGroupByGhsCode.length > 0
        ? selectedHazardsGroupByGhsCode
        : hazardsGroupByGhsCode;
    let content = selectedOrAllHazardsGroupByGhsCode
      .map(h => this.props.t(h.name))
      .join(separators.hazards);

    return (
      <Popup
        trigger={
          <img
            src={getHazardIconPath(hazardsGroupByGhsCode[0].id)}
            height="50"
            className="hazardCell"
          />
        }
        content={content}
      />
    );
  };
}

CPHazardsContainer.defaultProps = {
  showAllHazards: true
};

const mapStateToProps = state => ({
  hazardsCalculation: state.chemicalProducts.hazardsCalculation
});

const mapDispatchToProps = dispatch => ({
  envRiskCalculation: () => dispatch(risksActions.envRiskCalculation())
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(CPHazardsContainer);
